import React from 'react';
import { Switch } from 'react-router-dom';

import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';

import ThuVien from './thu-vien';
import ThuVienDetail from './thu-vien-detail';
import ThuVienUpdate from './thu-vien-update';
import ThuVienDeleteDialog from './thu-vien-delete-dialog';

const Routes = ({ match }) => (
  <>
    <Switch>
      <ErrorBoundaryRoute exact path={`${match.url}/new`} component={ThuVienUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id/edit`} component={ThuVienUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id`} component={ThuVienDetail} />
      <ErrorBoundaryRoute path={match.url} component={ThuVien} />
    </Switch>
    <ErrorBoundaryRoute exact path={`${match.url}/:id/delete`} component={ThuVienDeleteDialog} />
  </>
);

export default Routes;
